const defaultOptions = { vmProperty: '$modules' }
let modules = {}
let store = null
let router = null

/**
 * Helper to assure that shape of object is module definition(s)
 * @param {Object} mod
 */
const isModuleShape = (mod) => !!mod && typeof mod === 'object' && Object.keys(mod).length > 0

/**
 * Extract and register a module store
 * @param {string} key
 * @param {Object} mod
 * @param {Object} store
 */
export function registerModuleStore(key, mod, store) {
    if (!('store' in mod)) return false
    return store.registerModule(key, mod.store)
}

/**
 * Extract and register a module router
 * @param {Object} mod
 * @param {Object} router
 */
export function registerModuleRouter(mod, router) {
    if (!('router' in mod)) return false

    const { routes: moduleRoutes, ...moduleMethods } = mod.router

    if (moduleRoutes) {
        Object.keys(moduleRoutes).forEach((key) => {
            router.addRoute(moduleRoutes[key]);
        })
    }

    if (moduleMethods && Object.keys(moduleMethods).length > 0) {
        Object.keys(moduleMethods).forEach((moduleMethod) => {
            const methodName = moduleMethods[moduleMethod].name || moduleMethod
            if (typeof router[methodName] !== 'function') return
            router[methodName].call(router, moduleMethods[moduleMethod])
        })
    }

    return true;
}

/**
 * Define a vm instance property shorthand
 * @param {Object} app
 * @param {string} name
 */
export function registerVmProperty(app, name) {
    if (name in app.config.globalProperties) return false

    app.config.globalProperties[name] = modules

    return true;
}

/**
 * Register one or more modules
 * @param {Object} mods
 */
export function registerModules(mods) {
    if (!isModuleShape(mods)) return false

    modules = Object.assign(modules, mods)

    Object.keys(mods).forEach((modKey) => {
        const modDefinition = mods[modKey]
        if (store) registerModuleStore(modKey, modDefinition, store)
        if (router) registerModuleRouter(modDefinition, router)
    })

    return true;
}

/**
 * Return all registered modules
 * @returns {object} modules
 */
export function getModules() {
    return modules
}

/**
 * Resets all values (helpful for testing)
 */
export function reset() {
    modules = {}
    store = null
    router = null
}

/**
 * Install the plugin with app.use(VueModular, options)
 * @param {Object} app
 * @param {Object} [options]
 * @param {Object} [options.modules] - an object containing modules you want to register
 * @param {Object} [options.store] - a Vuex store instance
 * @param {Object} [options.router] - a Vue Router instance
 */
export default function (app, options = {}) {
    options = Object.assign({}, defaultOptions, options)
    if (options.store) store = options.store
    if (options.router) router = options.router
    if (options.vmProperty) registerVmProperty(app, options.vmProperty)
    if (isModuleShape(options.modules)) registerModules(options.modules)
}
